import {lazyRegister, registeredComponents} from '@/Core/lazyRegister';

export interface ILazyControllerFactory {
    load(controllerName: string, path?: string): Promise<string>;
}

lazyRegister.factory('LazyControllerFactory',
    function (): ILazyControllerFactory {
        function getFolderName(name) {
            if (!name) return '';
            return name
                .replace('_controller', '')
                .replace('_ctrl', '')
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join('');
        }

        function getFileName(name) {
            if (!name) return '';
            return name
                .replace('_controller', 'Controller')
                .replace('_ctrl', 'Controller')
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join('');
        }

        return {
            load: async (controllerName: string, path?: string) => {
                try {
                    if (registeredComponents.has(controllerName)) {
                        //console.log(`[LazyControllerFactory] Controller ${controllerName} already loaded, skip.`);
                        return controllerName;
                    }

                    if (!!path) {
                        const parts = path.split('/');
                        const rootFolder = parts[0];
                        const subPath = parts.slice(1).join('/');

                        await import(`@/${rootFolder}/${subPath}.ts`);
                        //console.log(`Controller ${controllerName} loaded from direct path: ${path}`);
                        return controllerName;
                    }

                    const folderName = getFolderName(controllerName);
                    const fileName = getFileName(controllerName);

                    // Thử load từ pages trước
                    try {
                        await import(`@/pages/${folderName}/${fileName}.ts`);
                        //console.log(`Controller ${controllerName} loaded from path: pages/${folderName}/${fileName}`);
                        return controllerName;
                    } catch (e) {
                        console.warn(`Could not load controller: ${controllerName} (Path tried: pages/${folderName}/${fileName}). Retry with Dialogs`);

                        // Thử load từ Components/Dialogs theo quy tắc đặt tên mặc định
                        try {
                            await import(`@/Components/Dialogs/${folderName}/${fileName}.ts`);
                            return controllerName;
                        } catch (e2) {
                            console.error(`Could not load controller: ${controllerName} from Components/Dialogs/${folderName}/${fileName})`, e2);
                        }
                    }
                } catch (err) {
                    console.error(`Không thể load controller: ${controllerName}`, err);
                }
            }
        };
    }
);
